<ng-container *ngIf="!isRegimenExpired">
  @if (acqRebranding2025) {
    <app-regimen-empty-state *ngIf="regimen" [iconSrc]="iconSrc" [iconClass]="$any(regimen.class)">
      @if (regimen.class !== appConfig.Shared.Regimen.Class.HAIR) {
        @if (isRegimenExpiredForPaidUser) {
          <p class="tw-text-center tw-font-bold tw-text-600 tw-leading-[24px] tw-px-4" i18n="@@AnswerFewQuestionsToRestartSkin">
            Answer a few questions <br/> to restart your skin treatment.
          </p>
        } @else {
          <p class="tw-text-center tw-font-bold tw-text-600 tw-leading-[24px]" i18n="@@skinGetStartedNowBr">
            Get started now <br/> with doctor given kit <br/> for your skin.
          </p>
        }
      } @else {
        @if (isRegimenExpiredForPaidUser) {
          <p class="tw-text-center tw-font-bold tw-text-600 tw-leading-[24px] tw-px-4" i18n="@@AnswerFewQuestionsToRestartHair">
            Answer a few questions <br/> to restart your hair treatment.
          </p>
        } @else {
          <p class="tw-text-center tw-font-bold tw-text-600 tw-leading-[24px]" i18n="@@hairGetStartedNowBr">
            Get started now <br/> with doctor given kit <br/> for your hair.
          </p>
        }
      }
      <p class="tw-text-center tw-text-300 tw-leading-[24px] tw-font-normal tw-mt-2" i18n="@@ItOnlyTakes2Minutes"> It only takes 2 minutes!</p>
    </app-regimen-empty-state>
  } @else {
    <div class="tw-w-full tw-h-full tw-font-body tw-bg-yellow-100 tw-pt-15" *ngIf="regimen">
      <img class="tw-mx-auto tw-w-20 tw-h-20" [src]="iconSrc" [class]="regimen.class" alt="faceIcon"/>
      @if (regimen.expired) {
        @if (regimen.class !== appConfig.Shared.Regimen.Class.HAIR) {
          <div class="tw-p-6 tw-text-200" i18n="@@skinTreatmentExpired">
            Your treatment kit has expired. Your skin condition might have changed.
            Please click below to get a new treatment.
          </div>
        } @else { 
          <div class="tw-p-6 tw-text-200" i18n="@@hairTreatmentExpired">
            Your treatment kit has expired. Your hair condition might have changed.
            Please click below to get a new treatment kit.
          </div>
        }
      } @else {
        <div class="tw-p-6 tw-text-200 tw-text-center" *ngIf="!regimen.expired && regimen.class !== appConfig.Shared.Regimen.Class.HAIR">
          <p class="tw-text-400 tw-font-body tw-font-bold" i18n="@@skinGetYourNewTreatment">
          Get started now with doctor given kit for your skin. It only takes 2
          minutes!
          </p>
        </div>
        <div class="tw-p-6 tw-text-200 tw-text-center" *ngIf="!regimen.expired && regimen.class === appConfig.Shared.Regimen.Class.HAIR">
          <p class="tw-text-300 tw-font-body tw-mb-4" i18n="@@hairGetYourNewTreatment">
          Get started now with doctor given kit for your hair. It only takes 2
          minutes!
          </p>
        </div>
      }
    </div>
  }
</ng-container>
<ng-container *ngIf="isRegimenExpired">
  <div class="tw-w-full tw-min-h-[calc(100vh-186px)] tw-flex tw-flex-col tw-items-center tw-justify-center tw-font-body tw-bg-gray-100">
    <div class="tw-w-max tw-h-max">
      <img class="tw-mx-auto tw-w-20 tw-h-20 tw-mb-4" [src]="iconSrc"/>
      @if (regimen.class === appConfig.Shared.Regimen.Class.HAIR) {
        <p class="tw-text-center tw-font-body tw-font-bold tw-text-500"> Get started with <br/> your hair treatment </p>
      } @else {
        <p class="tw-text-center tw-font-body tw-font-bold tw-text-500"> Get started with <br/> your skin treatment </p>
      }
      <p class="tw-text-center tw-font-body tw-font-normal tw-text-500"> to unlock doctor check-ups </p>
    </div>
  </div>
</ng-container>
